<template>
    <div>
        <my-form
        class="form-page"
        v-model="form"
        table
        readonly
        label-width="160px"
        @cancle="cancleHandler">

            <el-form-item
            label="标段(包)名称">
                {{form.bdname}}
            </el-form-item>

            <el-form-item
            label="提交时间">
                {{form.tjtime}}
            </el-form-item>
 
            <el-form-item
            label="评标委员会负责人">
                {{form.e_pbfzr}}
            </el-form-item>

            <el-form-item
            label="评标委员会成员">
                {{form.e_pbwy}}
            </el-form-item>
                                   
            <el-form-item
            label="报告内容" 
            class="table-full-row">
                <ueditor v-model="form.bgcontent" readonly></ueditor>
            </el-form-item>
            
            <el-form-item
            label="附件"
            class="table-full-row">
                <el-table
                    style="width:100%; margin-top:5px;"
                    v-bind:border="true"
                    v-bind:data="fileList"
                    empty-text="暂无文件">
                        <el-table-column label="文件名称" sortable>
                            <template slot-scope="scope">
                                <a
                                target="_blank"
                                :href="buildDownloadPath(scope.row)">
                                    {{scope.row.filename}}
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="fileuptime" label="上传时间" sortable></el-table-column>
                        <el-table-column prop="addusername" label="上传人"></el-table-column>
                    </el-table>
            </el-form-item>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

export default {
    mixins: [ FORM_PAGE_MIXIN ],
    components: { },
    data: () => ({
        form: {},
        isnzk:'',
        fileList:[],
    }),
    methods: {
        getFileList(list){
            var that = this;
            for (let index = 0; index < list.length; index++) {
                this.$ajax({
                    url: `${this.getGetters('fileUrl')}/operate/getlist.json`,
                    data:{
                        fileguid:list[index]
                    },
                    callback: data => {
                        that.fileList = that.fileList.concat(data);
                    }
                });
            }
            console.log(that.fileList);
        },
        buildDownloadPath(file) {
            var search = toSearch({
                rowguid: file.rowguid
            });
            return `${this.getGetters('fileUrl')}/download/common.do${search}`
        }
    },
    created() {
        var that = this;
        this.jspInit(`${this.getGetters('bidUrl')}/revision/kaibiao/pbbg/edit.json`, 
        {
            bgcode: this.getQuery('bgcode'),
            bdcode: this.getQuery('bdcode'),
        }
        , data => {
            that.form = data.model;
            that.getFileList(data.fileGuidList || []);
        });
    }
}
</script>

<style scoped lang="scss">

</style>
